module.exports = __webpack_public_path__ + "images/檀程长图_05.jpg?v=5833329b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_05.jpg
 ** module id = 191
 ** module chunks = 1 2
 **/